import { createSlice, PayloadAction} from "@reduxjs/toolkit";

export const passCodeUsersSlice = createSlice({
    name: 'passCodeUsers',
    initialState: {
      passCode:null,
      currentAnalyticsSessions:null,
      sessionSavingError: null,
      currentSessionRecordingPath: null
    }
  ,
    reducers: {
     // willLoginWithPassCode: (state, action:PayloadAction<any>) => state,
     willLogoutWithPassCode: (state, action:PayloadAction<any>) => state,
     willLoadAnalyticsSessions: (state, action:PayloadAction<any>) => state,

     setCurrentAnalyticsSessions: (state, action:PayloadAction<any>) =>{
       state.currentAnalyticsSessions = action.payload;
     },
     setCurrentSessionRecordingPath: (state, action:PayloadAction<any>) =>{
      state.currentSessionRecordingPath = action.payload;
    },

     resetSessionSavingError: (state) => { 
      state.sessionSavingError = null;
     },

     didSessionSavingError: (state, action:PayloadAction<any>) => { 
      state.sessionSavingError = action.payload;
     },

      didLoginWithPassCode: (state, action:PayloadAction<any>) => { 
        state.passCode = action.payload;
        state.sessionSavingError = null;
      },
      didLogoutWithPassCode: (state) => { 
        state.passCode = null;
      },
      // esporta la sessione su db
      willSaveSession: (state, action:PayloadAction<any>) => state,
    }
});

export const { actions, reducer } = passCodeUsersSlice

export const selectors = {
  isLoggedWithPassCode: (state:any) => {
    return state.passCodeUsers.passCode!=null;
  },

  getCurrentAnalyticsSessions: (state:any) => {
    return state.passCodeUsers.currentAnalyticsSessions;
  },

  getCurrentPassCode: (state:any) => {
    return state.passCodeUsers.passCode;
  },

  getCurrentSessionRecordingPath: (state:any) => {
    return state.passCodeUsers.currentSessionRecordingPath;
  },

  getSessionSavingError: (state:any) => {
    return state.passCodeUsers.sessionSavingError;
  }
}
